var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order",on:{"click":_vm.changeState}},[_c('svg-icon',{attrs:{"icon":_vm.icon,"svg-class":_vm.svgClass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }